module.exports = __webpack_public_path__ + "img/checked-img@2x.273dd6ff.png";